<template>
    <div class="relative w-64">
        <button class="flex items-center my-0 mx-auto" @click.prevent="toggle">
            <p class="mx-2 font-bold">{{ user.email }}</p>
            <font-awesome-icon :icon="['fas', 'chevron-down']" class="text-xs"></font-awesome-icon>
        </button>
        
        <button v-if="isOpen" @click.prevent="toggle" tabindex="-1" class="fixed inset-0 h-full w-full cursor-default"></button>
        <div class="switcher mt-4 w-64 block absolute top-full border border-gray-dark bg-white text-black text-sm rounded-md shadow-xl z-20" :class="isOpen ? '' : 'hidden'">
            <div v-for="secondary in user.owned" :key="secondary.email">
                <a :href="'/auth/' + secondary.id" class="p-2 my-1 hover:bg-gray-dark truncate flex items-center" :title="secondary.email" v-if="secondary.id != user.id">
                    <img :src="secondary.avatar_url" class=" flex-shrink-0 w-8 rounded-md m-2">
                    <div class="ml-2">
                        <p class="font-bold">{{ secondary.name }}</p>
                        <p>{{ secondary.email }}</p>
                    </div>
                </a>
            </div>
            <div>
                <span class="border-t border-gray-dark block" v-if="user.owned.length > 1"></span>
                <a href @click.prevent="addNew" class="block p-2 my-1 hover:bg-gray-dark truncate">
                    <p class="font-bold text-center">Add another inbox</p>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import ActiveSubscriptionRequiredModal from '../billing/ActiveSubscriptionRequiredModal.vue';

export default {
    data() {
        return {
            user        : User,
            isOpen      : false,
        }
    },
    methods: {
        toggle() {
            this.isOpen = !this.isOpen;
        },

        addNew() {
            // close the menu
            this.isOpen = false;
            
            if (window.User.permissions.use_feature_multiple_inboxes) {
                window.location = '/preauth';
                return;
            }

            Modal.show(ActiveSubscriptionRequiredModal);
        }
    }
}
</script>

<style lang="scss">
.switcher {
    left: 50%;
    transform: translateX(-50%);
}
</style>